import { render, staticRenderFns } from "./WidgetPassageExports.vue?vue&type=template&id=70714082&"
import script from "./WidgetPassageExports.vue?vue&type=script&lang=js&"
export * from "./WidgetPassageExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetPassageExports.vue"
export default component.exports